import { FC, useEffect, useState } from 'react'
import AppEditList from './app-edit-list';
import styles from './app-edit-price-fields.module.scss';
import { serviceAreas } from '../../services/service-areas';
import { useTranslation } from 'react-i18next';
import Field from '../../components/shared/Field/Field';

type Area = {
  name: string;
  _id: string;
  isActive: boolean;
  accountNumber?: string;
}

type CategoryItem = {
  label: string;
  value: string;
  accountNumber?: string;
}

const AppEditCategories : FC = () => {
  const [categories, setCategories] = useState<CategoryItem[]>([]);
  const [loading, setLoading] = useState(true);
  const [t] = useTranslation('settings', { keyPrefix: 'editCategories'});

  useEffect(() => {
    (async () => {
      const all = (await serviceAreas.getAreas() ?? []).map((x : Area) => ({ 
        label: x.name, 
        value: x._id,
        accountNumber: x.accountNumber 
      }));
      setCategories(all);
      setLoading(false);
    })();
  }, []);

  return <div>
    <p className={styles.intro}>
      {t('intro', 'Här kan du byta namn på eller ta bort yrkeskategorier. Namnbyten påverkar både befintliga upphandlingar och leverantörer. Borttagna kategorier försvinner från leverantörer men befintliga upphandlingar påverkas inte.')}
    </p>
    <AppEditList
      listType="categories"
      list={categories}
      loading={loading}
      filterFn={(item, search) => 
        item?.label.toLowerCase().includes(search.toLowerCase()) ||
        item?.accountNumber?.toLowerCase().includes(search.toLowerCase())
      }
      renderSubLabel={(item) => item.accountNumber ? (
        <span style={{ fontSize: '12px', color: 'var(--gray-500)' }}>
          {item.accountNumber}
        </span>
      ) : null}
      renderEditFields={(item, updateField) => (
        <Field
          label={t('edit.accountNumberLabel', 'Kontonummer')}
          value={item?.accountNumber || ''}
          onChange={(value) => updateField('accountNumber', value)}
        />
      )}
      onSave={async (item, id) => {
        await serviceAreas.updateAreaDetails(id, { 
          name: item.label, 
          accountNumber: item.accountNumber 
        });
        setCategories(prev => {
          const index = prev.findIndex(p => p?.value === id);
          const updated = [...prev];
          updated[index] = { 
            label: item.label, 
            value: id,
            accountNumber: item.accountNumber 
          };
          return updated;
        });
      }}
      onChangeLabel={async () => {}} // Not used when onSave is provided
      onDelete={async (id) => {
        await serviceAreas.deleteArea(id);
        setCategories(prev => {
          const index = prev.findIndex(p => p?.value === id);
          const updated = [...prev];
          updated.splice(index, 1);
          return updated;
        });
      }}
    />
  </div>;
}

export default AppEditCategories;
